module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-reviews"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "pages-reviews__header",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.reviews_banner + ')'
    })
  }), _c('BlockTitle', {
    attrs: {
      "props": _vm.props.acf.block_title
    }
  }), _c('ReviewsContent', {
    attrs: {
      "props": _vm.props.acf.reviews_links
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d121400","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/reviews/reviews.pug
// module id = 565
// module chunks = 1